import { render, staticRenderFns } from "./BillingSettings.vue?vue&type=template&id=2a57660e&"
import script from "./BillingSettings.vue?vue&type=script&lang=ts&"
export * from "./BillingSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports